// src/services/bannerService.js

import apiService from "./apiService";

// === BANNERS ===
const getAdminDashboardDetails = () => apiService.getAll("backend/dashboard/stats");


// === EXPORT ===
const dashboardService = {
  getAdminDashboardDetails,
};

export default dashboardService;
